import { Link } from "react-router-dom";

const PRIMARY = [
  ["Problem", "/problem"],
  ["Approach", "/approach"],
  ["About", "/about"],
  ["Platforms", "/platforms"],
  ["Process", "/process"],
  ["Pricing", "/pricing"],
  ["FAQ", "/faq"],
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#050505] py-16">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid md:grid-cols-12 gap-10 mb-12">
          <div className="md:col-span-4">
            <Link to="/" className="inline-flex items-center gap-2 mb-4">
              <span className="w-2.5 h-2.5 bg-yellow-400 inline-block" />
              <span className="font-heading text-sm tracking-tight font-medium">
                Invisible System Design
              </span>
            </Link>
            <p className="text-sm text-zinc-500 font-light leading-relaxed max-w-sm">
              Software that disappears into the apps you already use.
              Conversation-native, human-supervised, contemplatively built.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="text-xs uppercase tracking-[0.22em] text-zinc-600 font-mono mb-4">Navigate</div>
            <ul className="space-y-2 text-sm">
              {PRIMARY.map(([l, h]) => (
                <li key={l}>
                  <Link
                    to={h}
                    data-testid={`footer-link-${l.toLowerCase()}`}
                    className="text-zinc-400 hover:text-yellow-400 transition-colors"
                  >
                    {l}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="text-xs uppercase tracking-[0.22em] text-zinc-600 font-mono mb-4">Legal</div>
            <ul className="space-y-2 text-sm">
              <li>
                <Link
                  to="/legal/privacy"
                  data-testid="footer-link-privacy"
                  className="text-zinc-400 hover:text-yellow-400 transition-colors"
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link
                  to="/legal/terms"
                  data-testid="footer-link-terms"
                  className="text-zinc-400 hover:text-yellow-400 transition-colors"
                >
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="text-xs uppercase tracking-[0.22em] text-zinc-600 font-mono mb-4">Contact</div>
            <a
              href="mailto:Robert@InvisibleSystem.Design"
              data-testid="footer-email-link"
              className="font-mono text-sm text-white hover:text-yellow-400 transition-colors block mb-2"
            >
              Robert@InvisibleSystem.Design
            </a>
            <p className="text-xs text-zinc-500 font-light leading-relaxed">
              Agent speed. Human Oversight. Secure hosting.
            </p>
          </div>
        </div>

        <div className="border-t border-white/10 pt-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="font-mono text-[11px] uppercase tracking-[0.22em] text-zinc-600">
            © {new Date().getFullYear()} Invisible System Design · All quiet rights reserved.
          </div>
          <div className="font-mono text-[11px] uppercase tracking-[0.22em] text-zinc-600">
            built invisibly · v3.2
          </div>
        </div>
      </div>
    </footer>
  );
}
